import { getPlans, getRefunds } from '@/api/billing.js';

export default {
    state: {
        // Plans state
        plans: [],
        plansTotal: 0,
        includeInactivePlans: false,
        isPlansLoading: false,

        // Plan edit state
        isShowPlanEdit: false,
        planEditData: null,

        // Plan add state
        isShowPlanAdd: false,
        planAddData: {
            name: '',
            description: '',
            price: {
                amount: 0,
                currency: 'USD',
            },
            billing_period: 'monthly',
            trial_days: 0,
            max_downloads: 0,
            features: {},
            is_active: true,
        },

        // Refunds state
        refunds: [],
        isRefundsLoading: false,
        isShowRefundReview: false,
        refundReviewData: null,
    },

    getters: {
        // Plans getters
        BILLING_PLANS: (state) => state.plans,
        BILLING_PLANS_TOTAL: (state) => state.plansTotal,
        INCLUDE_INACTIVE_PLANS: (state) => state.includeInactivePlans,
        IS_PLANS_LOADING: (state) => state.isPlansLoading,

        // Plan edit getters
        IS_SHOW_PLAN_EDIT: (state) => state.isShowPlanEdit,
        PLAN_EDIT_DATA: (state) => state.planEditData,

        // Plan add getters
        IS_SHOW_PLAN_ADD: (state) => state.isShowPlanAdd,
        PLAN_ADD_DATA: (state) => state.planAddData,

        // Refunds getters
        BILLING_REFUNDS: (state) => state.refunds,
        IS_REFUNDS_LOADING: (state) => state.isRefundsLoading,
        IS_SHOW_REFUND_REVIEW: (state) => state.isShowRefundReview,
        REFUND_REVIEW_DATA: (state) => state.refundReviewData,
    },

    mutations: {
        // Plans mutations
        SET_BILLING_PLANS(state, { plans, total }) {
            state.plans = plans;
            state.plansTotal = total;
        },
        SET_INCLUDE_INACTIVE_PLANS(state, payload) {
            state.includeInactivePlans = payload;
        },
        SET_PLANS_LOADING(state, payload) {
            state.isPlansLoading = payload;
        },

        // Plan edit mutations
        IS_SHOW_PLAN_EDIT(state, payload) {
            state.isShowPlanEdit = payload;
        },
        PLAN_EDIT_SET(state, payload) {
            state.planEditData = payload;
        },

        // Plan add mutations
        IS_SHOW_PLAN_ADD(state, payload) {
            state.isShowPlanAdd = payload;
        },
        PLAN_ADD_DATA_RESET(state) {
            state.planAddData = {
                name: '',
                description: '',
                price: {
                    amount: 0,
                    currency: 'USD',
                },
                billing_period: 'monthly',
                trial_days: 0,
                max_downloads: 0,
                features: {},
                is_active: true,
            };
        },

        // Refunds mutations
        SET_BILLING_REFUNDS(state, payload) {
            state.refunds = payload;
        },
        SET_REFUNDS_LOADING(state, payload) {
            state.isRefundsLoading = payload;
        },
        IS_SHOW_REFUND_REVIEW(state, payload) {
            state.isShowRefundReview = payload;
        },
        REFUND_REVIEW_SET(state, payload) {
            state.refundReviewData = payload;
        },
    },

    actions: {
        async loadBillingPlans({ commit, state }) {
            commit('SET_PLANS_LOADING', true);
            try {
                const response = await getPlans({
                    include_inactive: state.includeInactivePlans,
                });
                commit('SET_BILLING_PLANS', {
                    plans: response.plans || [],
                    total: response.total || 0,
                });
            } catch (error) {
                console.error('Error loading billing plans:', error);
                commit('SET_BILLING_PLANS', { plans: [], total: 0 });
            } finally {
                commit('SET_PLANS_LOADING', false);
            }
        },

        async loadRefunds({ commit }) {
            commit('SET_REFUNDS_LOADING', true);
            try {
                const refunds = await getRefunds();
                commit('SET_BILLING_REFUNDS', refunds);
            } catch (error) {
                console.error('Error loading refunds:', error);
                commit('SET_BILLING_REFUNDS', []);
            } finally {
                commit('SET_REFUNDS_LOADING', false);
            }
        },
    },
};
